import hljs from 'highlight.js/lib/core';
import 'highlight.js/styles/atom-one-dark.css';
import css from 'highlight.js/lib/languages/css';
import xml from 'highlight.js/lib/languages/xml';
import bash from 'highlight.js/lib/languages/bash';
import json from 'highlight.js/lib/languages/json';
import scss from 'highlight.js/lib/languages/scss';
import javascript from 'highlight.js/lib/languages/javascript';

// ----------------------------------------------------------------------
// react-quill's syntax module reads window.hljs to highlight code blocks.
// Importing the full 'highlight.js' package pulled all 190+ language
// grammars (~970 kB minified). Registering only the languages used in
// the rich-text editor cuts this to a fraction of the size.
// Aliases handled by registered grammars:
//   - 'sh'   -> bash (bash registers 'sh' as alias)
//   - 'html' -> xml  (xml registers 'html' as alias)
//   - 'jsx'  -> javascript (javascript handles jsx via plain js grammar)

hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('bash', bash);
hljs.registerLanguage('xml', xml);
hljs.registerLanguage('scss', scss);
hljs.registerLanguage('css', css);
hljs.registerLanguage('json', json);

hljs.configure({
  languages: ['javascript', 'jsx', 'sh', 'bash', 'html', 'scss', 'css', 'json'],
});

// @ts-ignore
window.hljs = hljs;
